module.exports = __webpack_public_path__ + "static/media/qr_code.d825f904.jpg";